import { Box, Button, Text } from '@radix-ui/themes'
import { Gift } from 'lucide-react'
import { useState, useEffect } from 'react'

import { useAnnouncement } from '../hooks/useAnnouncement'
import { APP_RELEASE } from '../data/announcements'

import { UpdatesDialog } from './UpdatesDialog'
// Import for development testing utilities
import '../utils/resetAnnouncementState'

// The newest entry in the announcements registry. Publishing a release means
// putting its entry at the top of that list: the key below changes with it, so
// the dialog re-opens once for everyone, including users who dismissed the
// previous announcement.
const APP_VERSION = APP_RELEASE
const UPDATES_STORAGE_KEY = `com.veekls.skip-updates-alert-v${APP_VERSION}`

export const UpdatesButton = () => {
  // Controlled state for the dialog
  // It should be open if:
  // 1. auto-show is triggered (dialogOpen from hook is true)
  // 2. user manually clicks the button (updatesOpen local state is true)
  const [updatesOpen, setUpdatesOpen] = useState(false)

  const { dialogOpen, dismiss } = useAnnouncement({
    storageKey: UPDATES_STORAGE_KEY,
    autoShow: true,
  })

  // Sync auto-show state with local state
  useEffect(() => {
    if (dialogOpen) {
      setUpdatesOpen(true)
    }
  }, [dialogOpen])

  const handleOpenChange = (open: boolean) => {
    setUpdatesOpen(open)

    if (!open && dialogOpen) {
      // If closing and it was auto-opened, mark as seen
      dismiss()
    }
  }

  return (
    <>
      <Button variant="ghost" onClick={() => setUpdatesOpen(true)}>
        <Gift className="text-red-500" />
        <Box display={{ initial: 'none', sm: 'block' }} asChild>
          <Text>Novedades</Text>
        </Box>
      </Button>

      <UpdatesDialog open={updatesOpen} onOpenChange={handleOpenChange} />
    </>
  )
}
